import axios from 'axios';
import merge from 'lodash/merge';

/**
 * MaterialsService
 */
export default class MaterialsService
{
    public static path = 'admin/elearning/materials/materials';

    /**
     * @param filter FilterModel
     * @param pager Pager
     *
     * @returns Promise<Pagination<Resource<ListItemModel>>>
     */
    public static async getList(filter: FilterModel, pager: Pager): Promise<Pagination<Resource<ListItemModel>>>
    {
        return (await axios.get<Pagination<Resource<ListItemModel>>>(this.path, {
            params: merge({}, filter, pager.data())
        })).data;
    }

    /**
     * @param materialCategoryId number
     *
     * @returns Promise<ListItemModel[]>
     */
    public static async getElementsByCategory(materialCategoryId: number, unitType: string): Promise<ListItemModel[]>
    {
        return (await axios.get<ListItemModel[]>(`${this.path}/category/${materialCategoryId}`, {
            params: {
                unitType: unitType
            }
        })).data;
    }

    /**
     * @param id number
     *
     * @returns Promise<Resource<FormModel>>
     */
    public static async fetch(originId: number, unitOriginId: number = 0): Promise<Resource<FormModel>>
    {
        return (await axios.get<Resource<FormModel>>(`${this.path}/${unitOriginId}/${originId}`)).data;
    }

    /**
     * @param model FormModel
     *
     * @returns Promise<Resource<FormModel>>
     */
    public static async create(model: FormModel, unitOriginId: number = 0): Promise<Resource<FormModel>>
    {
        return (await axios.post<Resource<FormModel>>(`${this.path}/${unitOriginId}`, model)).data;
    }

    // /**
    //  * @param id number
    //  * @param model FormModel
    //  *
    //  * @returns Promise<Statement>
    //  */
    // public static async update(originId: number, forceOverride: boolean, model: FormModel): Promise<Resource<FormModel>>
    // {
    //     return (await axios.put<Resource<FormModel>>(`${this.path}/${originId}?override=${forceOverride}`, model)).data;
    // }

    /**
     * @param id number
     * @param model FormModel
     *
     * @returns Promise<Statement>
     */
    public static async update(unitOriginId: number, originId: number, model: FormModel): Promise<Resource<FormModel>>
    {
        return (await axios.put<Resource<FormModel>>(`${this.path}/${unitOriginId}/${originId}`, model)).data;
    }

    /**
     * @param id number
     *
     * @returns Promise<Statement>
     */
    public static async remove(id: number): Promise<Statement>
    {
        return (await axios.delete(`${this.path}/${id}`)).data as Statement;
    }

    /**
     * @param id number
     *
     * @returns Promise<Resource<FormModel>>
     */
    public static async fetchListItem(id: number): Promise<Resource<ListItemModel>>
    {
        return (await axios.get<Resource<ListItemModel>>(`${this.path}/autocomplete/${id}`)).data;
    }

    /**
     * @param search string
     * @param limit number
     * @param materialCategoryId number
     *
     * @returns Promise<ListItemModel[]>
     */
    public static async getAutocompleteList(search: string, unitType: string, materialCategoryId: number = 0, limit: number = 10): Promise<ListItemModel[]>
    {
        return (await axios.get<ListItemModel[]>(`${this.path}/autocomplete`, {
            params: {
                search: search,
                unitType: unitType,
                materialCategoryId,
                limit: limit
            }
        })).data;
    }

    /**
     * @param model ImportModel
     *
     * @returns Promise<Statement>
     */
    public static async import(model: ImportModel,): Promise<Statement>
    {
        return (await axios.post<Resource<ImportModel>>(`${this.path}/import`, model)).data as Statement;
    }

    /**
     * @param model GptContentCreatorFormModel
     *
     * @returns Promise<Resource<GptContentCreatorFormModel>>
     */
    public static async generateContent(model: GptContentCreatorFormModel): Promise<string>
    {
        return (await axios.post<string>(`${this.path}/gpt`, model)).data;
    }
    // public static async generateContent(model: GptContentCreatorFormModel): Promise<Resource<FormModel>>
    // {
    //     return (await axios.post<Resource<FormModel>>(`${this.path}/gpt`, model)).data;
    // }
}

export interface FilterModel
{
    name: string;
    categoryId?: number;
    type?: string;
}

export interface ListItemModel
{
    id: number;
    name: string;
    categoryId: number;
    categoryName: string;
    type: string;
    text: string;
    originId: number;
    maxResult: number;
    redirectUnitOriginId?: number;
    redirectMaterialOriginId?: number;
}

export interface FormModel
{
    id: number;
    name: string;
    categoryId: number;
    file?: FileResource;
    content: {
        value: any;
        type: string;
    };
    maxResult: number;
    redirectUnitOriginId?: number;
    redirectMaterialOriginId?: number;
}

export interface ImportModel
{
    pdfFile: string;
    materialName: string;
    categoryId: number;
}

// export interface GptContentCreatorFormModel
// {
//     language: string;
//     lessonName: string;
//     lessonDescription: string;
//     slideName: string;
//     slideCategory: string;
//     slideTypeName: string;
//     slideId: number;
//     slideTypeId: string;
//     userRemarks: string;
//     contentLength: string,
//     answerCount?: number,
//     questionCount?: number,
//     elementCompletedCount?: number,
//     categoryCount?: number,
//     itemCount?: number
// }

export interface GptContentCreatorFormModel
{
    material: GptMaterialModel;
    settings: GptSettingsModel;
}

export interface GptMaterialModel
{
    id: number;
    name: string;
    categoryName: string;
    contentType: string;
}

export interface GptSettingsModel
{
    language: string;
    userRemarks: string;
    contentLength: string;
    answerCount?: number;
    questionCount?: number;
    elementCompletedCount?: number;
    categoryCount?: number;
    itemCount?: number;
}
